import React from "react";
import { openEmail } from "../../utils/helpUtils";
import { MessageCircle, Mail, ArrowRight, Lightbulb } from "lucide-react";
import styles from "./ContactSupport.module.scss";

const ContactSupport: React.FC = () => {
  return (
    <div className={styles.contactSection}>
      <div className={styles.contactContainer}>
        <div className={styles.contactHeader}>
          <div className={styles.supportIcon}>
            <MessageCircle size={48} />
          </div>
          <h2>Need Additional Help?</h2>
          <p>Our support team is here to assist you with any questions or technical issues.</p>
        </div>
        
        <div className={styles.contactMethods}>
          <div className={styles.emailCard} onClick={openEmail}>
            <div className={styles.emailIcon}>
              <Mail size={40} />
            </div>
            <div className={styles.emailContent}>
              <h3>Email Support</h3>
              <p>Get in touch with our support team</p>
              <div className={styles.emailAddress}>
                connectapp@shi.org.il
              </div>
            </div>
            <div className={styles.emailArrow}>
              <ArrowRight size={24} />
            </div>
          </div>
        </div>
        
        <div className={styles.supportInfo}>
          <div className={styles.supportTip}>
            <div className={styles.tipIcon}>
              <Lightbulb size={20} />
            </div>
            <p>
              <strong>Tip:</strong> When contacting support, please include details about your issue 
              and any error messages you're seeing for faster assistance.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactSupport;